import { CmpsInsightCoachingPerformanceData } from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { CardPerformanceDataContainer as MetricItem } from '../../insight/models/card-performance-data-container.model';
import { epicDependencies } from '../../store';
import { PerformanceCardPillarData } from '../models/performance-card-pillar-data.model';
import { PillarItem } from '../models/pillar-item.model';
import { TranslationKeyMap } from '../my-performance-card.i18n';

import { extractMetrics } from './extract-metrics.function';
import {
    getProgressDataForPillar,
    processColourGroups,
} from './get-progress-data-for-pillar.function';
function createPillarItem(
    card: PerformanceCardPillarData,
    progressBarData: CmpsInsightCoachingPerformanceData[],
    metrics: MetricItem[],
): PillarItem {
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    return {
        titleLabel: card.name,
        progressBarData,
        metrics,
        launchButtonTooltip: translateService.instant(
            TranslationKeyMap._11178_VIEW_PILLAR_METRICS,
        ),
    };
}
export function performancePillars(
    card: PerformanceCardPillarData,
): PillarItem {
    const colourGroups = processColourGroups(card.colourGroups);
    const totalProgressData = getProgressDataForPillar(colourGroups);
    const metrics = extractMetrics(colourGroups);

    const mainPillar = createPillarItem(card, totalProgressData, metrics);

    return mainPillar;
}
